(function(){
    'use strict';

    angular.module('elogbooks.common.billing-settings', []);
})();
